import React from "react";
import {Modal} from "@mui/material";
import {AccountLocalAndTextSetting} from "./accountLocalAndTextSetting";

interface Props {
    isShow: boolean;
    closePopup: VoidFunction;
    settingForAccount: boolean;
}

export const AccountLocalAndTextSettingModal: React.FC<Props> = ({
                                                                     isShow,
                                                                     closePopup,
                                                                     settingForAccount
                                                                 }) => {
    return (
        <Modal
            open={isShow}
            sx={{
                display: `flex`,
                justifyContent: `center`,
                alignItems: `center`,
                zIndex: `5`
            }}
        >
            <>
                <AccountLocalAndTextSetting
                    closePopup={closePopup}
                    settingForAccount={settingForAccount}
                    readonly={false}
                />
            </>

        </Modal>
    )
}